export default "__VITE_ASSET__FKO2CRSW__"